// Centralised site data for The Tutor's Table
export const SITE = {
  name: "The Tutor's Table",
  tagline: "Primary 3–6 English & Math, taught with care.",
  description:
    "A focused tuition centre for Primary 3 to 6 students. Small classes of no more than 10, customised feedback, and curated notes to help every child grow with confidence.",
  whatsappNumberDisplay: "+65 8742 6325",
  whatsappNumberRaw: "6587426325",
  email: "ttutorstable@gmail.com",
  address: {
    line1: "Blk 702 Ang Mo Kio Ave 8",
    line2: "#02-2521",
    postal: "Singapore 560702",
    full: "Blk 702 Ang Mo Kio Ave 8, #02-2521, Singapore 560702",
  },
  logoUrl:
    "https://customer-assets.emergentagent.com/job_english-math-tutor-1/artifacts/vahxjygm_image.png",
  registrationFormUrl: "https://forms.gle/JKrRvzo7qvi2Jsf5A",
};

export const MAPS_EMBED_URL =
  "https://www.google.com/maps?q=Blk+702+Ang+Mo+Kio+Ave+8,+Singapore+560702&output=embed";

export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent("Blk 702 Ang Mo Kio Ave 8, #02-2521, Singapore 560702");

export const TESTIMONIALS = [
  {
    id: "t1",
    quote:
      "My son went from struggling with composition to scoring his first AL2 in English. The personal feedback on every essay is what really made the difference.",
    parent: "Mrs. Tan",
    child: "Parent of Ethan, P6",
    initials: "MT",
  },
  {
    id: "t2",
    quote:
      "The class size really matters. My daughter is shy and she would never raise her hand at school, but here she actually asks questions. We can see her confidence grow week by week.",
    parent: "Mr. & Mrs. Lim",
    child: "Parents of Sophie, P5",
    initials: "L",
  },
  {
    id: "t3",
    quote:
      "Honest, transparent fees and notes that are actually useful — no cardboard files of random worksheets. The tutor knows exactly what each child needs.",
    parent: "Mrs. Chua",
    child: "Parent of Marcus, P4",
    initials: "MC",
  },
];

export const WHATSAPP_LINK = (msg) =>
  `https://wa.me/${SITE.whatsappNumberRaw}?text=${encodeURIComponent(msg)}`;

export const EMAIL_LINK = (subject, body) =>
  `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const PROGRAMMES = [
  {
    id: "p3",
    level: "Primary 3",
    subjects: "English & Math",
    sessions: "4 sessions / month",
    duration: "1 hour 30 minutes per session",
    price: 220,
    perks: [
      "Builds early confidence",
      "Customised written feedback",
      "Curated notes & practice",
    ],
  },
  {
    id: "p4",
    level: "Primary 4",
    subjects: "English & Math",
    sessions: "4 sessions / month",
    duration: "1 hour 30 minutes per session",
    price: 220,
    perks: [
      "Strengthens foundation skills",
      "Customised written feedback",
      "Curated notes & practice",
    ],
  },
  {
    id: "p5",
    level: "Primary 5",
    subjects: "English & Math",
    sessions: "4 sessions / month",
    duration: "1 hour 30 minutes per session",
    price: 220,
    perks: [
      "Bridges P4 to PSLE rigour",
      "Customised written feedback",
      "Curated notes & practice",
    ],
  },
  {
    id: "p6",
    level: "Primary 6",
    subjects: "English & Math",
    sessions: "4 sessions / month",
    duration: "1 hour 30 minutes per session",
    price: 300,
    featured: true,
    perks: [
      "Targeted PSLE preparation",
      "Customised written feedback",
      "Curated notes & practice",
    ],
  },
];

// Schedule structured per level + subject
export const SCHEDULE = {
  P3: {
    English: [
      { day: "Monday", time: "4:00 – 5:30 PM" },
      { day: "Saturday", time: "9:00 – 10:30 AM" },
    ],
    Math: [
      { day: "Tuesday", time: "4:00 – 5:30 PM" },
      { day: "Sunday", time: "9:00 – 10:30 AM" },
    ],
  },
  P4: {
    English: [
      { day: "Wednesday", time: "4:00 – 5:30 PM" },
      { day: "Saturday", time: "10:45 AM – 12:15 PM" },
    ],
    Math: [
      { day: "Thursday", time: "4:00 – 5:30 PM" },
      { day: "Sunday", time: "10:45 AM – 12:15 PM" },
    ],
  },
  P5: {
    English: [
      { day: "Friday", time: "4:00 – 5:30 PM" },
      { day: "Saturday", time: "2:00 – 3:30 PM" },
    ],
    Math: [
      { day: "Thursday", time: "6:00 – 7:30 PM" },
      { day: "Sunday", time: "2:00 – 3:30 PM" },
    ],
  },
  P6: {
    English: [
      { day: "Monday", time: "6:00 – 7:30 PM" },
      { day: "Wednesday", time: "6:00 – 7:30 PM" },
      { day: "Friday", time: "6:00 – 7:30 PM" },
      { day: "Saturday", time: "3:45 – 5:15 PM" },
    ],
    Math: [
      { day: "Tuesday", time: "6:00 – 7:30 PM" },
      { day: "Sunday", time: "3:45 – 5:15 PM" },
    ],
  },
};

export const FEATURES = [
  {
    title: "Small classes, real attention",
    body:
      "Capped at 10 students per class so every child gets noticed, questions get answered, and progress is tracked.",
    icon: "Users",
  },
  {
    title: "Customised written feedback",
    body:
      "Personal feedback on every assignment — strengths to keep, gaps to close, and the next step to take.",
    icon: "PenLine",
  },
  {
    title: "Curated, exam-ready notes",
    body:
      "Notes hand-curated for the MOE syllabus — clean, concise, and exactly what your child needs to revise.",
    icon: "BookOpen",
  },
  {
    title: "No hidden fees",
    body:
      "$0 material fee. $0 deposit. $0 registration fee. Just a transparent monthly tuition fee, nothing else.",
    icon: "ShieldCheck",
  },
];
